export default __webpack_public_path__ + "static/media/proposals.b25fa6ef.png";